(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/board/board.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/board/board.js');

'use strict';




function parseBoard(board) {
  if (!board) {
    return;
  }
  if (Array.isArray(board.numbers)) {
    return board;
  }
  if (typeof board === 'string') {
    const numbers = board.match(/../g);
    return {
      numbers: numbers.map(number => Number(number))
    };
  }
  const systemType = Array.isArray(board.systemType) ? board.systemType[0] : 'SROW';
  return {
    numbers: board.boardData || board.boardData1 || board.boardValues,
    numbersExtra: board.boardData2 || board.boardExtraValues,
    rowPriceMulti: board.rowPriceMulti,
    isSystemBoard: systemType === 'MSYS',
    participation: board.participation,
    kungKeno: board.participation && board.participation.indexOf('KK') > -1
  };
}
if (svs.isServer) {
  module.exports = {
    parseBoard
  };
} else {
  svs.numbergames.mybets_core_wager.parsers.parseBoard = parseBoard;
}

 })(window);